import { render, staticRenderFns } from "./AddPersonModal.vue?vue&type=template&id=bc7f8eac&scoped=true&"
import script from "./AddPersonModal.vue?vue&type=script&lang=js&"
export * from "./AddPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPersonModal.vue?vue&type=style&index=0&id=bc7f8eac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7f8eac",
  null
  
)

export default component.exports